import { TForeignTradeByProductsState } from './types';

export function setProductAggregated(
  state: TForeignTradeByProductsState,
  data: TForeignTradeByProductsState['productAggregated'],
) {
  state.productAggregated = data;
}
